// extracted by mini-css-extract-plugin
module.exports = {"textMessage":"TextMessage_textMessage__2Bpbm","messageText":"TextMessage_messageText__3OfVZ","mention":"TextMessage_mention__Rwkkt","link":"TextMessage_link__2J0Xl"};